const schemaTableDataActionTypes = {
  SIGNOUT_SUCCESS: "SIGNOUT_SUCCESS",
  SET_SCHEMA_TABLE_DATA: "SET_SCHEMA_TABLE_DATA",
  REMOVE_SCHEMA_TABLE_DATA: "REMOVE_SCHEMA_TABLE_DATA",
};

export default schemaTableDataActionTypes;
